module.exports = __webpack_public_path__ + "img/logoTemp.2cf552c1.png";